import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { SignUp } from '../../modules/auth/components/sign-up';
import { setHtmlLoaderText, showHtmlLoader } from '../../ui/utils/html';

const AuthSignUpRoute = () => {
  const navigate = useNavigate();
  return (
    <SignUp
      onSignedUp={() => {
        showHtmlLoader();
        setHtmlLoaderText('Loading account information ...');

        navigate({ to: '/' });
      }}
    />
  );
};

export const Route = createFileRoute('/auth/signup')({
  component: AuthSignUpRoute,
});
